/**
 * Summary stats bar for the User list page.
 * Stats are filter-aware — they reflect the current filter state.
 */
function UserSummaryBar({ stats = {} }) {
    const { total = 0, active = 0 } = stats;
    const locked = total - active;

    return (
        <div className="flex flex-wrap items-center gap-4 px-4 py-2 bg-surface rounded-lg border text-sm">
            <span className="text-content-3">
                Tổng cộng: <strong className="text-content-2">{total.toLocaleString()}</strong>
            </span>
            <span className="text-green-600 border-l pl-4">
                Hoạt động: <strong>{active.toLocaleString()}</strong>
            </span>
            <span className="text-red-400 border-l pl-4">
                Bị khóa: <strong>{locked.toLocaleString()}</strong>
            </span>
        </div>
    );
}

export default UserSummaryBar;
